import img from '../../Assets/LearningPath/virtual-assistant.png'
const VirtualInput = [
    {
        key : 1,
        img : img,
        title : "Amazon FBA Private Label",
        btn : "Start Course",
        // link : "/learning-path/Virtual-Assistant/Privatelapel",
    },
    {
        key : 2,
        img : img,
        title : "Amazon FBA WholeSale",
        btn : "Start Course",
        // link : "/learning-path/Virtual-Assistant/WholeSale",
    },
    {
        key : 3,
        img : img,
        title : "Daraz Virtual Assistant",
        btn : "Start Course",
        // link : "/learning-path/Virtual-Assistant/Daraz",
    },
    
];
export default VirtualInput;